import { render } from "./code-field.vue?vue&type=template&id=4c6d2600&scoped=true&ts=true"
import script from "./code-field.vue?vue&type=script&lang=ts"
export * from "./code-field.vue?vue&type=script&lang=ts"

import "./code-field.vue?vue&type=style&index=0&id=4c6d2600&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6d2600"]])

export default __exports__